// extracted by mini-css-extract-plugin
export default {"who_needs_our_service":"WhoNeedsOurService_who_needs_our_service__FaTpg","item":"WhoNeedsOurService_item__Y1ITK","item_content":"WhoNeedsOurService_item_content__7QeuO"};